import erc721FactoryABI from "./erc721Factory.json";
import erc1155FactoryABI from "./erc1155Factory.json";
import raribleCollectionABI from "./raribleCollection.json";
import raribleExchangeABI from "./raribleExchange.json";
import usdcABI from "./usdc.json";

export const erc721Factory = erc721FactoryABI;
export const erc1155Factory = erc1155FactoryABI;
export const raribleCollection = raribleCollectionABI;
export const raribleExchange = raribleExchangeABI;
export const usdc = usdcABI;